import React, { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Privacy Policy - 10E Beauty";
  }, []);

  return (
    <div className="max-w-3xl mx-auto py-12 px-6 text-[#5c2f2f]">
      <h1 className="text-3xl font-bold mb-6 text-[#a25d5d]">Privacy Policy</h1>

      <p className="mb-4">
        At 10E Beauty, we respect your privacy and are committed to protecting
        the personal information you share with us. This Privacy Policy
        explains how we collect, use, and safeguard your information when you
        visit our website.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">Information We Collect</h2>
      <p className="mb-4">
        We may collect personal details such as your name, email, phone number,
        shipping address, and payment information when you make a purchase or
        register on our site.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">How We Use Your Information</h2>
      <ul className="list-disc list-inside mb-4 space-y-1">
        <li>To fulfill orders and process payments</li>
        <li>To communicate updates and offers</li>
        <li>To improve our website and customer experience</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">Data Security</h2>
      <p className="mb-4">
        We implement industry-standard security measures to protect your
        information. However, please be aware that no method of transmission
        over the internet is 100% secure.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">Your Rights</h2>
      <p className="mb-4">
        You may request to access, update, or delete your personal data at any
        time by contacting us.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">Changes to This Policy</h2>
      <p className="mb-4">
        We may update this policy occasionally. All changes will be posted on
        this page with a revised date.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-2 text-[#8c4444]">Contact Us</h2>
      <p className="mb-12">
        If you have any questions regarding this Privacy Policy, please contact
        us at{" "}
        <a
          href="mailto:support@10ebeauty.com"
          className="text-[#a25d5d] underline hover:text-[#c37676]"
        >
          support@10ebeauty.com
        </a>
        .
      </p>
    </div>
  );
};

export default PrivacyPolicy;
